import React from 'react';
import { Link } from 'react-router-dom';

import './button.css';

const Button = (props) => {
    return (
        <div className="btn-container">
            <div className="btn-core">{props.label}</div>
            <Link to={props.link} className="btn-mask">
                {props.label}
            </Link>
        </div>
    );
};

export default Button;
